import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController} from '@ionic/angular';
import { GoogleMapsComponent } from '../../../../components/google-maps/google-maps';
import { IconPipe } from '../../../../pipes/icon/icon';
import { EventListModel } from '../../../../providers/event/event';
import { GoogleMapsProvider } from '../../../../providers/google-maps/google-maps';
import { EventTabsPage } from '../../details/event-tabs/event-tabs';
import { EventListPage } from '../../event-list/event-list';
import { Router } from '@angular/router';


/**
 * Generated class for the EventSearchMapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-event-search-map',
  templateUrl: 'event-search-map.html',
  styleUrls:['./event-search-map.scss']
})
export class EventSearchMapPage {

  @ViewChild('map') mapElement: ElementRef;
  marker: any;
  @ViewChild(GoogleMapsComponent)
  maps: GoogleMapsComponent;

  events: EventListModel[];
  constructor(
    public navCtrl: NavController, 
    private iconPipe: IconPipe, 
    private router:Router,
    private googleMaps: GoogleMapsProvider) {
    console.log("event-search-map.ts constructor()");
    // this.events = navParams.data.events.filter(x => x.lat !== null && x.lng !== null);
    const nav = this.router.getCurrentNavigation();
    console.log('nav', nav)
    const state = nav?.extras?.state as { events?: any[] };
    if (state?.events) {
      this.events = state.events.filter(x => x.lat !== null && x.lng !== null);
    } else {
      this.events = [];
    }
  }

  ngAfterContentInit() {

  }

  mapLoaded(map) {
    this.googleMaps.getGoogle().then(async (google) => {
      var me = this;
      let markers = [];
      var bounds = new google.maps.LatLngBounds();

      for (let index = 0; index < this.events.length; index++) {
        let icon = await this.iconPipe.transform(this.events[index].cid + "", "marker");
        let marker = new google.maps.Marker({
          position: this.events[index],
          icon: icon
        });
        marker.addListener('click', function () {
          console.log(marker.containedModel);
          this.navCtrl.navigateForward('/event/details/tabs',{state:{event: marker.containedModel}});
          // (me.app.getRootNav() as NavController).push(EventTabsPage, { event: marker.containedModel });
        });
        marker.containedModel = this.events[index];
        markers.push(marker);
        bounds.extend(marker.getPosition());
      }




      map.fitBounds(bounds);

      // @ts-ignore
      var markerCluster = new MarkerClusterer(map, markers,
        {
          zoomOnClick: false,
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
        });
      google.maps.event.addListener(markerCluster, 'clusterclick', async function (cluster) {
        let containedEvents = [];
        await cluster.getMarkers().forEach(marker => {
          containedEvents.push(marker.containedModel);
          console.log(marker.containedModel);
        });
        this.navCtrl.navigateForward('/event/list', {state:{events: containedEvents}});
        // (me.app.getRootNav() as NavController).push(EventListPage, { events: containedEvents });
      });
    });


  }

}
